import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-16 bg-white" data-id="element-64">
      <div className="container mx-auto px-4" data-id="element-65">
        <div className="text-center mb-12" data-id="element-66">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-67">Contact Us</h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-68">
            Ready to restore your property's appearance? Get in touch with us
            for a free quote.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-69">
          <div className="lg:w-1/2" data-id="element-70">
            <form className="space-y-4" data-id="element-71">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-72">
                <div data-id="element-73">
                  <label htmlFor="name" className="block text-gray-700 mb-1" data-id="element-74">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600" placeholder="Your name" data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <label htmlFor="email" className="block text-gray-700 mb-1" data-id="element-77">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600" placeholder="Your email" data-id="element-78" />
                </div>
              </div>
              <div data-id="element-79">
                <label htmlFor="phone" className="block text-gray-700 mb-1" data-id="element-80">
                  Phone
                </label>
                <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600" placeholder="Your phone number" data-id="element-81" />
              </div>
              <div data-id="element-82">
                <label htmlFor="service" className="block text-gray-700 mb-1" data-id="element-83">
                  Service Needed
                </label>
                <select id="service" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-84">
                  <option value="" data-id="element-85">Select a service</option>
                  <option value="residential" data-id="element-86">
                    Residential Pressure Washing
                  </option>
                  <option value="commercial" data-id="element-87">
                    Commercial Pressure Washing
                  </option>
                  <option value="soft" data-id="element-88">Soft Washing</option>
                  <option value="sealing" data-id="element-89">Surface Sealing</option>
                </select>
              </div>
              <div data-id="element-90">
                <label htmlFor="message" className="block text-gray-700 mb-1" data-id="element-91">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600" placeholder="Tell us about your project" data-id="element-92"></textarea>
              </div>
              <button type="submit" className="bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-93">
                Get a Free Quote
              </button>
            </form>
          </div>
          <div className="lg:w-1/2" data-id="element-94">
            <div className="bg-gray-50 p-6 rounded-lg h-full" data-id="element-95">
              <h3 className="text-xl font-semibold mb-6 text-gray-900" data-id="element-96">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-97">
                <div className="flex items-start" data-id="element-98">
                  <MapPinIcon size={20} className="text-green-600 mt-1 mr-3 flex-shrink-0" data-id="element-99" />
                  <div data-id="element-100">
                    <p className="font-medium text-gray-900 mb-3" data-id="element-101">
                      Proudly Serving Communities Across Charlotte, NC
                    </p>
                    <div className="grid grid-cols-3 gap-x-4 gap-y-1 text-sm" data-id="element-102">
                      <p className="text-gray-600" data-id="element-103">Charlotte</p>
                      <p className="text-gray-600" data-id="element-104">Huntersville</p>
                      <p className="text-gray-600" data-id="element-105">Concord</p>
                      <p className="text-gray-600" data-id="element-106">Mount Holly</p>
                      <p className="text-gray-600" data-id="element-107">Belmont</p>
                      <p className="text-gray-600" data-id="element-108">Pineville</p>
                      <p className="text-gray-600" data-id="element-109">Weddington</p>
                      <p className="text-gray-600" data-id="element-110">Monroe</p>
                      <p className="text-gray-600" data-id="element-111">Mooresville</p>
                      <p className="text-gray-600" data-id="element-112">Gastonia</p>
                      <p className="text-gray-600" data-id="element-113">Indian Trail</p>
                      <p className="text-gray-600" data-id="element-114">Rock Hill</p>
                      <p className="text-gray-600" data-id="element-115">Fort Mill</p>
                      <p className="text-gray-600" data-id="element-116">Kannapolis</p>
                      <p className="text-gray-600" data-id="element-117">Cornelius</p>
                      <p className="text-gray-600 font-medium" data-id="element-118">And More!</p>
                    </div>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-119">
                  <PhoneIcon size={20} className="text-green-600 mt-1 mr-3 flex-shrink-0" data-id="element-120" />
                  <div data-id="element-121">
                    <p className="font-medium text-gray-900" data-id="element-122">Phone</p>
                    <p className="text-gray-600" data-id="element-123">980 500 9213</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-124">
                  <MailIcon size={20} className="text-green-600 mt-1 mr-3 flex-shrink-0" data-id="element-125" />
                  <div data-id="element-126">
                    <p className="font-medium text-gray-900" data-id="element-127">Email</p>
                    <p className="text-gray-600" data-id="element-128">
                      professor.pressure.washing.nc@gmail.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-129">
                  <ClockIcon size={20} className="text-green-600 mt-1 mr-3 flex-shrink-0" data-id="element-130" />
                  <div data-id="element-131">
                    <p className="font-medium text-gray-900" data-id="element-132">Business Hours</p>
                    <p className="text-gray-600" data-id="element-133">Monday - Friday: 8am - 6pm</p>
                    <p className="text-gray-600" data-id="element-134">Saturday: 9am - 4pm</p>
                    <p className="text-gray-600" data-id="element-135">Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};